// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.div-file[data-v-19b8f7d6] {\n  display: inline-block;\n}\n.div-file > button[data-v-19b8f7d6] {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
